import { SpecifierName } from '@gin-betting/constants';
import { View } from '@gin-betting/core';

function isDefault(market: View.Market): boolean {
    return !market.specifiers.some(s => {
        return s.name === SpecifierName.total || s.name === SpecifierName.hcp;
    });
}

function isMobileDefault(market: View.Market): boolean {
    return [1, 20].includes(market.typeId);
}

function isHCP({ specifiers }: View.Market): boolean {
    return (
        specifiers.some(s => s.name === SpecifierName.hcp) &&
        !specifiers.some(s => s.name === SpecifierName.total)
    );
}

function isTotal(market: View.Market): boolean {
    return market.specifiers.some(s => {
        return s.name === SpecifierName.total;
    });
}

export default { isDefault, isMobileDefault, isHCP, isTotal };
